import { render, staticRenderFns } from "./addressList.vue?vue&type=template&id=149aa1ca&"
import script from "./addressList.vue?vue&type=script&lang=ts&"
export * from "./addressList.vue?vue&type=script&lang=ts&"
import style0 from "./addressList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports